var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flag (1) 1",
    clipPath: "url(#clip0_1626_133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1626_133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3292",
    d: "M16.4669 8.50106C16.4669 10.6148 15.6273 12.6419 14.1326 14.1366C12.638 15.6312 10.6109 16.4709 8.49713 16.4709C6.3834 16.4709 4.35625 15.6312 2.86162 14.1366C1.36699 12.6419 0.527313 10.6148 0.527313 8.50106C0.527313 6.38734 1.36699 4.36018 2.86162 2.86555C4.35625 1.37092 6.3834 0.53125 8.49713 0.53125C10.6109 0.53125 12.638 1.37092 14.1326 2.86555C15.6273 4.36018 16.4669 6.38734 16.4669 8.50106Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1626_133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3220",
    d: "M16.4688 0.53125H11.1563V16.4688H16.4688V0.53125Z",
    fill: "#E32D3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3990",
    d: "M11.1563 0.53125H5.84378V16.4688H11.1563V0.53125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3992",
    d: "M5.84378 0.53125H0.531281V16.4688H5.84378V0.53125Z",
    fill: "#2B4896"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.7a2c6233f29de879a287d05ab7951f3a.svg";
export { ForwardRef as ReactComponent };